import React from 'react';
import { Fragment } from 'preact';
export class HyperlinkInput extends React.Component {

    onValueChanged = (event) => {
        this.props.field.setValue(event.target.value, this.props.userEditKey);
        this.props.onValueChanged(this.props.field);
    }

    render() {
        return (
            <Fragment>
                {
                    (this.props.editMode == true) &&
                    <input type="text"
                        id={this.props.field.inputElementId}
                        name={this.props.field.inputElementName}
                        value={this.props.field.value}
                        onChangeCapture={this.onValueChanged}
                        class={this.props.cssClass} />
                }
                {
                    (this.props.editMode == false) &&
                    <a href={this.props.field.value} target="_blank">{this.props.field.value}</a>
                }
            </Fragment>
        );
    }

}
